import React, { useState } from "react";
import FormModal from "./FormModal";
import "../Styles/AppointmentBtn.css";

const AppointmentBtn = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <button className="appointment-btn" onClick={() => setIsModalOpen(true)}>
        Book Appointment
      </button>
      <FormModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default AppointmentBtn;
